import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Company } from '../../functional/models/company';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UserService } from '../../services/user/user.service';
import { DatePipe } from '@angular/common';
import { User } from '../../functional/models/user';

@Component({
  selector: 'app-user-selector-dialog',
  templateUrl: './user-selector-dialog.component.html',
  styleUrls: ['./user-selector-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserSelectorDialogComponent implements OnInit {
  userForm!: UntypedFormGroup;
  company?: Company;
  customerSearch = true;
  allowEmployees = true;
  onlyEmployees: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<UserSelectorDialogComponent>,
    private userService: UserService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    this.company = data.company;
    this.allowEmployees = data.allowEmployees;
    this.onlyEmployees = data.onlyEmployees;
  }

  async ngOnInit(): Promise<void> {
    this.userForm = this.formBuilder.group({
      users: new UntypedFormArray([]),
    });

    for (const user of this.data?.users || []){
      this.newUser(user);
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  get f() { return this.userForm.controls; }
  get t() { return this.f.users as UntypedFormArray; }

  newUser(user?: User) {
    this.t.push(this.formBuilder.group({
      id: [user?.id, []],
      role: [user?.role || 3 , []],
      description: [user?.description || '', []],
      companyId: [user?.companyId || this.company?.id, []],
      firstName: [user?.firstName, Validators.required],
      lastName: [user?.lastName, Validators.required],
      email: [user?.email, [Validators.required, Validators.email]],
      phone: [user?.phone || '', []],
      gender: [user?.gender || 0, []],
      street: [user?.street || '', []],
      postalCode: [user?.postalCode || '', []],
      premise: [user?.premise || '', []],
      houseNumber: [user?.houseNumber || '', []],
      city: [user?.city || '', []],
      birth: [user?.birth || '', []],
      relationId: [user?.relationId, []],
      sendMail: [!user?.id, []]
    }));
  }

  async onSubmit() {
    for (const form of this.t.controls) {
      if (form.invalid) {
        form.markAllAsTouched();
      }
    }

    if (this.userForm.invalid) {
      return;
    }

    const updatedUsers = [];

    for (const user of this.userForm.value.users) {
      const parsedUser = user as User;

      if (parsedUser.birth) {
        parsedUser.birth = this.datePipe.transform(parsedUser.birth, 'yyyy-MM-dd');
      }

      if (parsedUser.id) {
        const sanitizedUser: any = {...parsedUser};
        delete sanitizedUser.id;

        updatedUsers.push(await this.userService.editUser(parsedUser.id, sanitizedUser));
      } else {
        updatedUsers.push(await this.userService.createUser(parsedUser, user.sendMail));
      }
    }

    this.dialogRef.close( {data: {users: updatedUsers}});
  }

  onUserSelected(user: User | undefined) {
    if (user) {
      const find = this.userForm.value.users.find((u: User) => u.id === user.id);
      if (!find) {
        this.newUser(user);
      }
      this.customerSearch = false;
    }
  }

  deleteUser(i: number) {
    this.t.removeAt(i);
  }
}
